<template>
	<div>
		<div v-if="giftcard.deliveryMethod == deliveryMethods.MAIL.id">
			<!-- <mail-shipping v-model="currentStep" :giftcard.sync="giftcard"/>> -->
			<mail-shipping v-model="giftcard" v-on:onValidationChange="handleValidationChange" v-bind:currentStep="currentStep" />
		</div>
		<div v-if="giftcard.deliveryMethod == deliveryMethods.SMS.id">
			<sms-shipping v-model="giftcard" v-on:onValidationChange="handleValidationChange" />
		</div>
		<div v-if="giftcard.deliveryMethod == deliveryMethods.PDF.id" class="mb-5">
			<pdf-shipping v-model="giftcard" v-on:onValidationChange="handleValidationChange" />
		</div>

		<section>
			<v-btn text @click="currentStep--">Tilbake</v-btn>
			<v-btn class="ml-3" color="primary" depressed @click="goToNextStep" :disabled="!valid">Gå videre</v-btn>
		</section>
	</div>
</template>

<script>
import MailShipping from './child-components/MailShipping';
import SMSShipping from './child-components/SMSShipping';
import PdfShipping from './child-components/PdfShipping';
import { DeliveryMethodEnum } from '@/services/enums/deliveryMethods';
import { GiftCardPurchaseDetails } from '@/services/models';
import { User } from '@/services/models';
import AppSvc from '@fixit/fixit-no-header/src/services/app-svc';
let service = null;
export default {
	name: 'buy-giftcard-shipping',
	components: { 'mail-shipping': MailShipping, 'sms-shipping': SMSShipping, 'pdf-shipping': PdfShipping },
	props: {
		giftcard: GiftCardPurchaseDetails,
		value: null // Current step
	},
	async created() {
		service = await AppSvc(this.useAxios ? this.$axios : null);

		// Listen for successfull login or profile created
		this.$eventBus.$on('user-logged-in', this.userLoggedInCallback);
	},
	data() {
		return {
			valid: false,
			delivery: { SENDTOYOURSELV: 0, SENDTOOTHER: 1 },
			deliveryMethods: DeliveryMethodEnum
		};
	},
	computed: {
		currentStep: {
			get() {
				return this.value || -1;
			},

			set(value) {
				this.$emit('input', value);
			}
		}
	},
	methods: {
		handleValidationChange(value) {
			this.valid = value;
		},
		async goToNextStep() {
			if (this.valid) {
				// Make sure we check if the user is still logged in
				const profile = await service.getCurrentUser(process.env.VUE_APP_FIXIT_CORE_API_URL);
				let isLoggedInClient = window.CONFIG.user && window.CONFIG.user.onlineSluttKundeId > 0;

				// TODO: Should be refactored into vue store (user)
				if (!profile && isLoggedInClient) {
					this.$user.assign(new User());
					this.$eventBus.$emit('user-logged-out');
					isLoggedInClient = false;
				}

				if (profile && isLoggedInClient && window.CONFIG.user.email.length == 0) {
					this.$eventBus.$emit('snackbar', {
						text: 'Profilen din mangler epostadresse, vennligst oppdater profilen din',
						type: 'info',
						top: 'top'
					});
					const overrides = {
						loginDescription: 'For å kjøpe gavekort må du ha en gylidg epost adresse. Vennligst oppdater profilen din.',
						currentForm: 'force_verify',
						mobile: window.CONFIG.user ? window.CONFIG.user.mobile : null
					};
					this.$eventBus.$emit('login-dialog', true, overrides);
				} else if (profile && isLoggedInClient) {
					this.currentStep++;
				} else {
					// Prompt login
					let overrideForm = null;
					if (this.giftcard.deliveryToReceiver == this.delivery.SENDTOYOURSELV) {
						const form = {
							receiverFirstName: this.giftcard.receiverFirstName,
							receiverLastName: this.giftcard.receiverLastName,
							deliveryAddress: this.giftcard.deliveryAddress,
							deliveryPostalCode: this.giftcard.deliveryPostalCode,
							deliveryPostalArea: this.giftcard.deliveryPostalArea
						};
						overrideForm = form;
					}
					const overrides = {
						loginDescription: 'For å kjøpe gavekort må du være innlogget. Logg inn eller opprett en ny bruker.',
						currentForm: 'recovery',
						overrideForm: overrideForm
					};
					this.$eventBus.$emit('login-dialog', true, overrides);
				}
			}
		},
		userLoggedInCallback(user) {
			if (this.currentStep == 3 && user && user.onlineSluttKundeId > 0) {
				this.goToNextStep();
			}
		}
	}
};
</script>
